(function() {
  const SID_KEY = '_bkt_sid';
  const JOURNEY_KEY = '_bkt_j';
  // Use Temdata API endpoint for IP/geo capture (routes through our server)
  const API_ENDPOINT = 'https://www.temdata.com/api/track';
  const UPDATE_INTERVAL = 30000;

  let maxScroll = 0;
  let pageHeight = 0;
  let st = Date.now();

  // Keep path for grouping, but also keep full path + query for attribution tags like ?ref=
  let ct = window.location.pathname;
  let full = window.location.pathname + window.location.search;

  function gid() {
    let s = sessionStorage.getItem(SID_KEY);
    if (!s) {
      s = 'bkt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem(SID_KEY, s);
    }
    return s;
  }

  function getShopifyY() {
    const match = document.cookie.match(/_shopify_y=([^;]+)/);
    return match ? match[1] : null;
  }

  function getShopifyCustomerId() {
    // Method 1: Check ShopifyAnalytics global (most reliable for logged-in users)
    if (window.ShopifyAnalytics?.meta?.page?.customerId) {
      return window.ShopifyAnalytics.meta.page.customerId.toString();
    }
    // Method 2: Check __st global object
    if (window.__st?.cid) {
      return window.__st.cid.toString();
    }
    // Method 3: Check meta tag (some themes expose it)
    const metaCustomer = document.querySelector('meta[name="shopify-customer-id"]');
    if (metaCustomer?.content) {
      return metaCustomer.content;
    }
    return null;
  }

  function getKlaId() {
    const match = document.cookie.match(/__kla_id=([^;]+)/);
    if (!match) return null;
    try {
      const decoded = atob(match[1]);
      const parsed = JSON.parse(decoded);
      return parsed.$anonymous || parsed.p || null;
    } catch (e) {
      return null;
    }
  }

  function gj() {
    const j = sessionStorage.getItem(JOURNEY_KEY);
    return j ? JSON.parse(j) : [];
  }

  function sj(data) {
    sessionStorage.setItem(JOURNEY_KEY, JSON.stringify(data));
  }

  function gi() {
    const params = new URLSearchParams(window.location.search);

    // Firehose (structured): capture ALL query parameters, any key
    const query_params = {};
    for (const [k, v] of params.entries()) query_params[k] = v;

    const utm_source = params.get('utm_source');
    const utm_medium = params.get('utm_medium');
    const utm_campaign = params.get('utm_campaign');
    const utm_term = params.get('utm_term');

    return {
      // existing fields
      sid: gid(),
      ref: document.referrer || null, // HTTP referrer (previous site/page)
      ua: navigator.userAgent,

      // existing marketing fields (kept for backward compatibility)
      us: utm_source,
      um: utm_medium,
      uc: utm_campaign,
      ut: utm_term,

      gclid: params.get('gclid'),
      gbraid: params.get('gbraid'),
      gad_source: params.get('gad_source'),
      gad_campaignid: params.get('gad_campaignid'),

      // NEW: human-readable duplicates (no guessing)
      http_referrer: document.referrer || null,
      utm_source: utm_source,
      utm_medium: utm_medium,
      utm_campaign: utm_campaign,
      utm_term: utm_term,

      // NEW: capture your custom link tag clearly (e.g. ?ref=robtest)
      ref_tag: params.get('ref'),

      // NEW: capture every query tag as an object
      query_params: query_params,

      vw: window.innerWidth,
      vh: window.innerHeight,

      // Device & browser info
      lang: navigator.language || navigator.userLanguage,
      platform: navigator.platform,
      screen_w: window.screen.width,
      screen_h: window.screen.height,
      device_pixel_ratio: window.devicePixelRatio || 1,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

      ts: new Date().toISOString()
    };
  }

  function tp(entry) {
    const j = gj();
    j.push(entry);
    sj(j);
  }

  function sp(completed) {
    const payload = {
      session_id: gid(),
      journey: gj(),
      completed: completed || false,
      email: null,
      shopify_y: getShopifyY(),
      shopify_customer_id: getShopifyCustomerId(),
      kla_id: getKlaId()
    };

    fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
      keepalive: completed
    }).catch(() => {});
  }


  function getElInfo(el) {
    if (!el) return {};
    const info = {
      tag: el.tagName,
      id: el.id || null,
      cls: el.className || null,
      txt: (el.innerText || el.textContent || '').trim().substring(0, 100),
      href: el.href || null,
      type: el.type || null,
      name: el.name || null,
      value: el.value || null
    };

    // Add image-specific attributes
    if (el.tagName === 'IMG') {
      info.src = el.src || el.getAttribute('data-src') || null;
      info.alt = el.alt || null;
      info.title = el.title || null;
      // Get parent link if image is wrapped in <a>
      const parentLink = el.closest('a');
      if (parentLink) {
        info.parent_href = parentLink.href;
      }
    }

    return info;
  }

  // CAPTURE PAGEVIEW IMMEDIATELY - DON'T WAIT FOR DOM
  tp({
    ...gi(),
    p: ct,        // path only (for grouping)
    url: full,    // path + query string (firehose text)
    t: 'pv'
  });

  sp(false);

  // ATTACH INTERACTIVE TRACKING AFTER DOM IS READY
  function attachInteractiveTracking() {
    setInterval(function() {
      sp(false);
    }, UPDATE_INTERVAL);

    window.addEventListener('beforeunload', function() {
      const dur = Math.round((Date.now() - st) / 1000);
      const scrollPct = pageHeight ? Math.round((maxScroll / pageHeight) * 100) : 0;
      tp({
        p: ct,
        url: full,
        t: 'exit',
        d: dur,
        scroll: scrollPct,
        ts: new Date().toISOString()
      });
      // Note: completed is set via Shopify order webhook, not here
      sp(false);
    });

    document.addEventListener('click', function(e) {
      tp({
        t: 'clk',
        ...getElInfo(e.target),
        x: e.clientX,
        y: e.clientY,
        ts: new Date().toISOString()
      });
    }, true);

    document.addEventListener('submit', function(e) {
      tp({
        t: 'submit',
        ...getElInfo(e.target),
        ts: new Date().toISOString()
      });
    }, true);


    document.addEventListener('change', function(e) {
      if (e.target.tagName === 'SELECT' || e.target.tagName === 'INPUT') {
        tp({
          t: 'change',
          ...getElInfo(e.target),
          ts: new Date().toISOString()
        });
      }
    }, true);

    // Try to get product info from page context
    function getProductInfo() {
      let product = null;

      // Method 1: Shopify product JSON (most reliable on product pages)
      try {
        const productJson = document.querySelector('[data-product-json]');
        if (productJson) {
          product = JSON.parse(productJson.textContent);
        }
      } catch(e) {}

      // Method 2: ShopifyAnalytics meta (available on product pages)
      if (!product && window.ShopifyAnalytics?.meta?.product) {
        product = window.ShopifyAnalytics.meta.product;
      }

      // Method 3: Check for product in meta tags
      if (!product) {
        const ogTitle = document.querySelector('meta[property="og:title"]');
        const ogType = document.querySelector('meta[property="og:type"]');
        if (ogType?.content === 'product' && ogTitle?.content) {
          product = { title: ogTitle.content };
        }
      }

      // Method 4: Parse from URL if on product page
      if (!product && window.location.pathname.includes('/products/')) {
        const match = window.location.pathname.match(/\/products\/([^/?]+)/);
        if (match) {
          // Convert handle to readable title (best-ketone-test -> Best Ketone Test)
          const handle = match[1];
          const title = handle.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
          product = { title: title, handle: handle };
        }
      }

      return product;
    }

    // Intercept fetch for cart operations - CAPTURE PRODUCT DATA
    const origFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      const options = args[1] || {};

      if (url && typeof url === 'string') {
        // Skip Tabarnam app background cart syncs (noisy, not real user actions)
        // Remove this check if we need to track Tabarnam cart events later
        if (url.includes('tabarnapp') || url.includes('_tbn_ignored')) {
          return origFetch.apply(this, args);
        }
        if (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change')) {
          try {
            // Parse the request body to extract product info
            let cartData = null;
            if (options.body) {
              if (typeof options.body === 'string') {
                try {
                  // Try JSON parse first
                  cartData = JSON.parse(options.body);
                } catch(e) {
                  // If not JSON, try FormData parsing
                  const formData = new URLSearchParams(options.body);
                  cartData = {
                    id: formData.get('id') || formData.get('variant_id'),
                    quantity: formData.get('quantity'),
                    properties: {}
                  };
                  // Capture any additional form data
                  for (const [key, value] of formData.entries()) {
                    if (key !== 'id' && key !== 'variant_id' && key !== 'quantity') {
                      cartData.properties[key] = value;
                    }
                  }
                }
              }
            }

            // Get product info from page context
            const productInfo = getProductInfo();

            tp({
              t: 'cart_add',
              url: url,
              method: options.method || 'POST',
              variant_id: cartData?.id || cartData?.variant_id || null,
              quantity: cartData?.quantity || 1,
              properties: cartData?.properties || null,
              product_title: productInfo?.title || null,
              product_handle: productInfo?.handle || null,
              page_path: window.location.pathname,
              ts: new Date().toISOString()
            });
          } catch(err) {
            // Fallback - log event without product details
            tp({
              t: 'cart_api',
              url: url,
              method: options.method || 'POST',
              page_path: window.location.pathname,
              error: 'Failed to parse cart data',
              ts: new Date().toISOString()
            });
          }
        }
      }

      return origFetch.apply(this, args);
    };

    // Intercept XMLHttpRequest for cart operations - CAPTURE PRODUCT DATA
    const origXHROpen = window.XMLHttpRequest.prototype.open;
    const origXHRSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function(method, url) {
      this._method = method;
      this._url = url;
      return origXHROpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function(body) {
      if (this._url && typeof this._url === 'string') {
        // Skip Tabarnam app background cart syncs
        if (this._url.includes('tabarnapp') || this._url.includes('_tbn_ignored')) {
          return origXHRSend.apply(this, arguments);
        }
        if (this._url.includes('/cart/add') || this._url.includes('/cart/update') || this._url.includes('/cart/change')) {
          try {
            let cartData = null;
            if (body) {
              if (typeof body === 'string') {
                try {
                  cartData = JSON.parse(body);
                } catch(e) {
                  const formData = new URLSearchParams(body);
                  cartData = {
                    id: formData.get('id') || formData.get('variant_id'),
                    quantity: formData.get('quantity'),
                    properties: {}
                  };
                  for (const [key, value] of formData.entries()) {
                    if (key !== 'id' && key !== 'variant_id' && key !== 'quantity') {
                      cartData.properties[key] = value;
                    }
                  }
                }
              } else if (body instanceof FormData) {
                cartData = {
                  id: body.get('id') || body.get('variant_id'),
                  quantity: body.get('quantity'),
                  properties: {}
                };
                for (const [key, value] of body.entries()) {
                  if (key !== 'id' && key !== 'variant_id' && key !== 'quantity') {
                    cartData.properties[key] = value;
                  }
                }
              }
            }

            // Get product info from page context
            const productInfo = getProductInfo();

            tp({
              t: 'cart_add',
              url: this._url,
              method: this._method || 'POST',
              variant_id: cartData?.id || cartData?.variant_id || null,
              quantity: cartData?.quantity || 1,
              properties: cartData?.properties || null,
              product_title: productInfo?.title || null,
              product_handle: productInfo?.handle || null,
              page_path: window.location.pathname,
              ts: new Date().toISOString()
            });
          } catch(err) {
            tp({
              t: 'cart_xhr',
              url: this._url,
              method: this._method || 'POST',
              page_path: window.location.pathname,
              error: 'Failed to parse cart data',
              ts: new Date().toISOString()
            });
          }
        }
      }

      return origXHRSend.apply(this, arguments);
    };

    function trackScroll() {
      const scrollPos = window.scrollY + window.innerHeight;
      pageHeight = document.documentElement.scrollHeight;
      if (scrollPos > maxScroll) {
        maxScroll = scrollPos;
      }
    }

    window.addEventListener('scroll', trackScroll, { passive: true });
    trackScroll();

    const obsModal = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            const isModal = node.classList?.contains('modal') ||
                          node.classList?.contains('popup') ||
                          node.classList?.contains('klaviyo') ||
                          node.getAttribute('role') === 'dialog';

            if (isModal) {
              tp({
                t: 'modal_opened',
                ...getElInfo(node),
                ts: new Date().toISOString()
              });
            }
          }
        });
      });
    });

    obsModal.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachInteractiveTracking);
  } else {
    attachInteractiveTracking();
  }
})();
